import { io } from "socket.io-client";
import { postAPI } from "./useAPI";

export const server_url: string = process.env.REACT_APP_HOST || "";

export const socket = io(server_url);
  
interface socketListenerProps {
    setSocketMsg: ({id, msg}: {id:string, msg: string}) => void,
    myId: string
}


export const socketListener = ({setSocketMsg, myId}: socketListenerProps) => {

    socket.on('send_message', ({ msg, id }) => {

        if(myId !== id && msg !== "") setSocketMsg({id:id, msg:msg});
    });

    socket.on('disconnect', () => {
        setTimeout(() => {
            socket.connect();
        }, 5000);
    });
}

export const joinRoom = (roomId: number) => {
    console.log('join_room');
    socket.emit('join_room', {roomId: roomId});
}

export const leaveRoom = (roomId: number) => {
    console.log('leave_room');
    socket.emit('leave_room', {roomId: roomId});
}

export const sendMsg = ({roomId, id, msg} : {roomId: number, id: string, msg: string}) => {
    socket.emit('send_message', { roomId: roomId, msg: msg, id: id });
};